import { centerConstants } from "../../constants";

const { CENTER_FORM_STATE } = centerConstants;

const initialState = {
  formState: null,
};

const centerReducer = (state = initialState, action) => {
  switch (action.type) {
    case CENTER_FORM_STATE:
      return {
        ...state,
        formState: action.data,
      };

    default:
      return state;
  }
};

export default centerReducer;
